import * as React from 'react';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import BasicDto from 'types/__models__/BasicDto';
import TextBox from 'components/shared/edit/fields/TextBox';
import { ModelStatus } from 'shared-client/types/model-status';
import { RedirectData } from 'types';
import ValidationErrorAlert, { AlertType } from '~/components/shared/edit/ValidationErrorAlert';

interface Redirect301OnTheFlyFormProps {
	record: UrlDto;
	siteNames: string[];
	submitError: string | string[] | null;
	initialValue: RedirectData[];
	fieldName?: string;
}

interface UrlDto extends BasicDto {
	url: string;
	status: ModelStatus;
}

/**
 * Component for creating a 301 redirect on the fly when a record's scope has changed during publishing
 * or when deleting records.
 */
function Redirect301OnTheFlyForm({
	record,
	siteNames,
	submitError,
	initialValue,
	fieldName = '__redirects',
}: Redirect301OnTheFlyFormProps) {
	React.useEffect(() => {
		//setting focus to the 1st 301 'site redirect URL' input only on the first render of the component and fieldName changes.
		const input = document.getElementById(`${fieldName}[0].redirectUrl`);

		if (input) {
			input.focus();
		}
	}, [fieldName]);

	return (
		<>
			<p>URL: {record.url}</p>

			<ValidationErrorAlert submitError={submitError} alertType={AlertType.Edit} />

			<div className="input-grid">
				<FieldArray name={fieldName} initialValue={initialValue}>
					{({ fields }) =>
						fields.map((field, index) => {
							const siteName = siteNames[index];

							return (
								<div
									className="input-grid__item"
									key={index}
									data-testid={`redirect-url-item-${index}`}
								>
									{/* There is intentionally no validation on this field, as users should be allowed to redirect any URL to any other URL. */}
									<Field
										name={`${field}.redirectUrl`}
										label={`${siteName} Redirect URL`}
										component={TextBox}
										formatOnBlur
										isShared={false}
									/>
								</div>
							);
						})
					}
				</FieldArray>
			</div>
		</>
	);
}

export default Redirect301OnTheFlyForm;
